/* Bad Hombre Outdoors storefront behavior */
(() => {
  const B = window.BHO || {};
  const routes = B.routes || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = B.moneyFormat || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const group = (v, d, t, s) => {
      const [i, f] = v.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return group(n, 2, "'", '.');
      return group(n, 2, ',', '.');
    });
  }
  const esc = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg, err) {
    const t = $('[data-toast]');
    if (!t) return;
    $('[data-toast-msg]', t).textContent = msg;
    t.classList.toggle('err', !!err);
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('on'), 2600);
  }

  /* ---------- dialogs ---------- */
  function openDialog(id) {
    const d = document.getElementById(id);
    if (!d || d.open) return;
    d._opener = document.activeElement;
    d.showModal();
  }
  function closeDialog(d) {
    if (!d?.open) return;
    d.close();
  }
  document.addEventListener('close', (e) => {
    const d = e.target;
    if (d instanceof HTMLDialogElement && d._opener instanceof HTMLElement) d._opener.focus();
  }, true);
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t instanceof HTMLDialogElement) {
      const r = t.getBoundingClientRect();
      const panel = t.firstElementChild;
      const pr = panel && panel !== t ? panel.getBoundingClientRect() : r;
      if (e.clientX < pr.left || e.clientX > pr.right || e.clientY < pr.top || e.clientY > pr.bottom) closeDialog(t);
      return;
    }
    if (!(t instanceof Element)) return;
    const closer = t.closest('[data-close]');
    if (closer) return closeDialog(closer.closest('dialog'));
    const opener = t.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openDialog(opener.dataset.open);
      if (opener.dataset.open === 'bho-search') setTimeout(() => $('#bho-search input[type="search"]')?.focus(), 30);
    }
  });

  /* ---------- cart ---------- */
  function setCount(n, bump) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      if (bump) {
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
      }
    });
  }
  async function getCart() {
    const r = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('Cart unavailable');
    return r.json();
  }
  function renderCart(cart) {
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="cart-empty"><p>Your cart's empty, hombre. Nothing biting yet.</p><a class="btn" href="${routes.root}collections/all">Shop the drop</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = `<ul class="cart-lines">${cart.items
      .map((i) => {
        const img = i.image ? `<img src="${esc(i.image)}${i.image.includes('?') ? '&' : '?'}width=160" alt="${esc(i.product_title)}" width="76" height="76" loading="lazy">` : '';
        const meta = i.product_has_only_default_variant ? '' : `<p class="meta">${esc(i.variant_title)}</p>`;
        return `<li class="cart-line">${img}<div><h3><a href="${esc(i.url)}">${esc(i.product_title)}</a></h3>${meta}
          <div class="mini-qty"><button type="button" data-line-change="${esc(i.key)}" data-qty="${i.quantity - 1}" aria-label="Decrease quantity">−</button><span>${i.quantity}</span><button type="button" data-line-change="${esc(i.key)}" data-qty="${i.quantity + 1}" aria-label="Increase quantity">+</button></div></div>
          <span class="lp">${money(i.final_line_price)}</span></li>`;
      })
      .join('')}</ul>`;
    if (foot) {
      foot.hidden = false;
      $('[data-cart-subtotal]', foot).textContent = money(cart.total_price);
    }
  }
  async function refreshCart(bump) {
    try {
      const cart = await getCart();
      renderCart(cart);
      setCount(cart.item_count, bump);
      return cart;
    } catch {
      return null;
    }
  }
  async function addToCart(id, quantity = 1) {
    const r = await fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    await refreshCart(true);
    return data;
  }
  let lineBusy = false;
  document.addEventListener('click', async (e) => {
    const b = e.target instanceof Element && e.target.closest('[data-line-change]');
    if (!b || lineBusy) return;
    lineBusy = true;
    try {
      const r = await fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.dataset.lineChange, quantity: Math.max(0, Number(b.dataset.qty)) }),
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || 'Could not update cart');
      renderCart(cart);
      setCount(cart.item_count);
    } catch (err) {
      toast(err.message, true);
    } finally {
      lineBusy = false;
    }
  });
  document.addEventListener('click', (e) => {
    const a = e.target instanceof Element && e.target.closest('[data-cart-open]');
    if (!a || !document.getElementById('bho-cart')) return;
    e.preventDefault();
    openDialog('bho-cart');
  });

  /* ---------- predictive search ---------- */
  let searchCtrl;
  let searchTimer;
  document.addEventListener('input', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-predictive]')) return;
    const out = document.getElementById(input.getAttribute('aria-controls'));
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      const q = input.value.trim();
      if (!out) return;
      if (q.length < 2) {
        out.innerHTML = '';
        return;
      }
      searchCtrl?.abort();
      searchCtrl = new AbortController();
      try {
        const url = new URL(`${routes.predictiveSearch}.json`, location.origin);
        url.searchParams.set('q', q);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        const r = await fetch(url, { signal: searchCtrl.signal });
        const data = await r.json();
        const items = data?.resources?.results?.products || [];
        out.innerHTML = items.length
          ? items
              .map((p) => {
                const img = p.featured_image?.url || p.image;
                return `<li><a href="${esc(p.url)}">${img ? `<img src="${esc(img)}${String(img).includes('?') ? '&' : '?'}width=120" alt="" width="56" height="56" loading="lazy">` : '<span></span>'}<div><b>${esc(p.title.replace(/^Bad Hombre Outdoors\s+/i, ''))}</b><span>${money(Math.round(Number(p.price) * (String(p.price).includes('.') ? 100 : 1)))}</span></div></a></li>`;
              })
              .join('')
          : `<li style="color:var(--muted)">Nothing biting for “${esc(q)}”.</li>`;
      } catch (err) {
        if (err.name !== 'AbortError') out.innerHTML = '';
      }
    }, 220);
  });

  /* ---------- reveal ---------- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      }), { threshold: 0.15 })
    : null;
  function initReveal(root) {
    $$('.rv:not(.in)', root).forEach((el) => (io ? io.observe(el) : el.classList.add('in')));
  }

  /* ---------- product cards ---------- */
  function cardVariants(card) {
    if (!card._variants) {
      try {
        card._variants = JSON.parse($('[data-variants]', card)?.textContent || '[]');
      } catch {
        card._variants = [];
      }
    }
    return card._variants;
  }
  function pickVariant(list, color, size = 'M') {
    const ofColor = list.filter((v) => !color || v.c === color);
    return ofColor.find((v) => v.s === size && v.a) || ofColor.find((v) => v.a) || ofColor[0];
  }
  function setCardColor(card, sw) {
    if (!sw) return;
    $$('.sw', card).forEach((s) => {
      const on = s === sw;
      s.classList.toggle('on', on);
      s.setAttribute('aria-pressed', on);
    });
    card.style.setProperty('--tee-color', sw.dataset.hex);
    card.classList.toggle('is-light', !!sw.dataset.light);
    const v = pickVariant(cardVariants(card), sw.dataset.color);
    const add = $('[data-quick-add]', card);
    if (v) {
      const price = $('[data-price]', card);
      if (price) price.textContent = money(v.p);
      if (add) {
        add.dataset.variant = v.id;
        add.disabled = !v.a;
        add.innerHTML = v.a ? `Quick add${v.s ? ` · Size <span data-size>${esc(v.s)}</span>` : ''}` : 'Sold out';
      }
    }
  }
  function setCardColorByName(card, name) {
    const sw = $$('.sw', card).find((s) => s.dataset.color === name);
    if (sw) setCardColor(card, sw);
  }
  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const card = t.closest('[data-card]');
    if (!card) return;
    const sw = t.closest('.sw');
    if (sw) return setCardColor(card, sw);
    const flip = t.closest('[data-flip]');
    if (flip) {
      const on = card.classList.toggle('show-front');
      flip.setAttribute('aria-pressed', on);
      return;
    }
    const add = t.closest('[data-quick-add]');
    if (add) {
      if (add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      try {
        await addToCart(add.dataset.variant, 1);
        const color = $('.sw.on', card)?.dataset.color;
        const size = $('[data-size]', add)?.textContent;
        toast(`Added: ${card.dataset.name}${color ? `, ${color}` : ''}${size ? `, ${size}` : ''}`);
      } catch (err) {
        toast(err.message, true);
      } finally {
        add.removeAttribute('aria-busy');
      }
      return;
    }
    const stage = t.closest('.tee-stage');
    if (stage && !t.closest('button, a')) location.href = stage.dataset.href;
  });

  /* ---------- home line tabs ---------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach((wrap) => {
      if (wrap._init) return;
      wrap._init = true;
      const section = wrap.closest('[data-shop]') || document;
      const tabs = $$('.tab', wrap);
      const pill = $('.tab-pill', wrap);
      const cards = $$('[data-card]', section);
      let line = wrap.dataset.default || 'men';
      const place = () => {
        const a = tabs.find((t) => t.dataset.line === line);
        if (!a || !pill) return;
        pill.style.width = `${a.offsetWidth}px`;
        pill.style.transform = `translateX(${a.offsetLeft - 5}px)`;
        pill.style.background = line === 'women' ? 'var(--pink)' : 'var(--bone)';
      };
      const set = (l) => {
        line = l;
        tabs.forEach((t) => {
          const on = t.dataset.line === l;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
        });
        let k = 0;
        cards.forEach((c) => {
          const show = l === 'all' || c.dataset.line === l;
          c.hidden = !show;
          if (show) {
            c.style.animation = 'none';
            void c.offsetWidth;
            c.style.animation = '';
            c.style.animationDelay = `${k++ * 70}ms`;
          }
        });
        const empty = $('[data-grid-empty]', section);
        if (empty) empty.hidden = k > 0;
        place();
      };
      tabs.forEach((t) => t.addEventListener('click', () => set(t.dataset.line)));
      wrap.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = tabs.findIndex((t) => t.dataset.line === line);
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        set(n.dataset.line);
        n.focus();
      });
      window.addEventListener('resize', place);
      wrap._set = set;
      set(line);
      requestAnimationFrame(place);
      document.fonts?.ready.then(place);
    });
  }
  document.addEventListener('click', (e) => {
    const a = e.target instanceof Element && e.target.closest('[data-set-line]');
    if (!a) return;
    const tabs = $('[data-tabs]');
    if (!tabs?._set) return;
    const href = a.getAttribute('href') || '';
    if (href && !href.startsWith('#')) return;
    e.preventDefault();
    tabs._set(a.dataset.setLine);
    (tabs.closest('[data-shop]') || tabs).scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- collection ---------- */
  function initCollection(root) {
    $$('[data-collection]', root).forEach((sec) => {
      if (sec._init) return;
      sec._init = true;
      const grid = $('[data-cgrid]', sec);
      const cards = $$('[data-card]', grid);
      const promo = $('[data-promo]', grid);
      const empty = $('[data-empty]', grid);
      const count = $('[data-count]', sec);
      const colorRow = $('[data-color-filter]', sec);
      const params = new URLSearchParams(location.search);
      const state = { pursuit: params.get('pursuit') || '', color: '', sort: 'feat', cols: 3 };
      if (colorRow && !$('.cf', colorRow)) {
        const seen = new Map();
        cards.forEach((c) => $$('.sw', c).forEach((sw) => seen.has(sw.dataset.color) || seen.set(sw.dataset.color, sw.dataset.hex)));
        const clearBtn = $('[data-clear]', colorRow);
        seen.forEach((hex, name) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'cf';
          b.dataset.cf = name;
          b.style.background = hex;
          b.title = name;
          b.setAttribute('aria-label', name);
          b.setAttribute('aria-pressed', 'false');
          colorRow.insertBefore(b, clearBtn);
        });
        if (!seen.size) colorRow.hidden = true;
      }

      const apply = () => {
        let list = cards.filter(
          (c) => (!state.pursuit || c.dataset.pursuit === state.pursuit) && (!state.color || c.dataset.colors.split('|').includes(state.color)),
        );
        const sorted = [...list];
        if (state.sort === 'az') sorted.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name) || a.dataset.line.localeCompare(b.dataset.line));
        if (state.sort === 'pursuit') sorted.sort((a, b) => a.dataset.pursuit.localeCompare(b.dataset.pursuit));
        if (state.sort === 'new') sorted.sort((a, b) => Number(b.dataset.published) - Number(a.dataset.published));
        if (state.sort === 'feat') sorted.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));
        cards.forEach((c) => (c.hidden = !list.includes(c)));
        sorted.forEach((c, k) => {
          grid.insertBefore(c, empty);
          c.style.animation = 'none';
          void c.offsetWidth;
          c.style.animation = '';
          c.style.animationDelay = `${k * 60}ms`;
          if (state.color) setCardColorByName(c, state.color);
        });
        if (promo) {
          const show = !state.pursuit && !state.color && sorted.length >= 4;
          promo.hidden = !show;
          if (show) grid.insertBefore(promo, sorted[state.cols === 4 ? 4 : 3] || empty);
        }
        if (empty) empty.hidden = sorted.length > 0;
        if (count) count.textContent = `${sorted.length} tee${sorted.length === 1 ? '' : 's'}`;
        grid.style.setProperty('--cols', state.cols);
        $$('.chip', sec).forEach((c) => {
          const on = (c.dataset.pu || '') === state.pursuit;
          c.classList.toggle('on', on);
          c.setAttribute('aria-pressed', on);
        });
        $$('.cf', sec).forEach((c) => {
          const on = c.dataset.cf === state.color;
          c.classList.toggle('on', on);
          c.setAttribute('aria-pressed', on);
        });
        const clear = $('[data-clear]', colorRow);
        if (clear) clear.hidden = !(state.pursuit || state.color);
        const url = new URL(location.href);
        if (state.pursuit) url.searchParams.set('pursuit', state.pursuit);
        else url.searchParams.delete('pursuit');
        history.replaceState(history.state, '', url);
      };

      sec.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        const chip = t.closest('.chip');
        if (chip) {
          state.pursuit = chip.dataset.pu || '';
          return apply();
        }
        const cf = t.closest('.cf');
        if (cf) {
          state.color = state.color === cf.dataset.cf ? '' : cf.dataset.cf;
          return apply();
        }
        if (t.closest('[data-clear]')) {
          state.pursuit = '';
          state.color = '';
          return apply();
        }
        const cb = t.closest('.cols button');
        if (cb) {
          state.cols = Number(cb.dataset.c);
          $$('.cols button', sec).forEach((b) => {
            b.classList.toggle('on', b === cb);
            b.setAttribute('aria-pressed', b === cb);
          });
          apply();
        }
      });
      $('[data-sort]', sec)?.addEventListener('change', (e) => {
        state.sort = e.target.value;
        apply();
      });
      apply();
    });
  }

  /* ---------- product ---------- */
  function initProduct(root) {
    $$('[data-product]', root).forEach((sec) => {
      if (sec._init) return;
      sec._init = true;
      let data;
      try {
        data = JSON.parse($('[data-product-json]', sec).textContent);
      } catch {
        return;
      }
      const form = $('[data-product-form]', sec);
      const idInput = $('[data-variant-id]', sec);
      const addBtn = $('[data-add]', sec);
      const stickyAdd = $('[data-sticky-add]', sec);
      const sizeName = $('[data-size-name]', sec);
      const qtyInput = $('[data-qty]', sec);
      const state = { color: data.color, size: data.size || null, slide: 0 };
      const slides = $$('.slide', sec);
      const thumbs = $$('.thumb-btn', sec);
      const caption = $('[data-caption-out]', sec);
      const main = $('[data-main-img]', sec);

      const current = () => data.variants.find((v) => (!data.hasColor || v.c === state.color) && (!data.hasSize || v.s === state.size));
      const basePrice = () => {
        const ofColor = data.variants.filter((v) => !data.hasColor || v.c === state.color);
        return Math.min(...ofColor.map((v) => v.p));
      };

      const update = () => {
        const v = current();
        const base = basePrice();
        const qty = Math.max(1, Number(qtyInput?.value) || 1);
        $$('[data-size-btn]', sec).forEach((b) => {
          const sv = data.variants.find((x) => (!data.hasColor || x.c === state.color) && x.s === b.dataset.size);
          b.classList.toggle('on', b.dataset.size === state.size);
          b.setAttribute('aria-checked', b.dataset.size === state.size);
          b.classList.toggle('out', !sv || !sv.a);
          const up = sv ? sv.p - base : 0;
          let small = $('small', b);
          if (up > 0) {
            if (!small) {
              small = document.createElement('small');
              b.append(small);
            }
            small.textContent = `+${money(up).replace(/\.00(?=\D*$)/, '')}`;
          } else small?.remove();
        });
        const shown = v || data.variants.find((x) => (!data.hasColor || x.c === state.color) && x.a) || data.variants[0];
        $$('[data-pprice]', sec).forEach((el) => (el.textContent = money(shown.p)));
        const cmp = $('[data-pcompare]', sec);
        if (cmp) {
          cmp.hidden = !(shown.cp > shown.p);
          cmp.textContent = shown.cp > shown.p ? money(shown.cp) : '';
        }
        const missing = data.hasSize && !!state.size && !v;
        const soldOut = missing || (v && !v.a);
        const avail = $('[data-avail]', sec);
        if (avail) {
          if (!avail.dataset.ok) avail.dataset.ok = avail.classList.contains('ok') ? avail.textContent : 'Printed to order';
          const ok = !soldOut && (v ? v.a : shown.a);
          avail.textContent = ok ? avail.dataset.ok : missing ? 'Unavailable' : 'Sold out';
          avail.classList.toggle('ok', ok);
          avail.classList.toggle('no', !ok);
        }
        if (idInput && v) idInput.value = v.id;
        [addBtn, stickyAdd].forEach((b) => {
          if (!b) return;
          b.disabled = !!soldOut;
        });
        const label = missing ? 'Unavailable' : soldOut ? 'Sold out' : 'Add to cart';
        $$('[data-add-label]', sec).forEach((el) => (el.textContent = label));
        $$('[data-add-price]', sec).forEach((el) => (el.textContent = money(shown.p * qty)));
        if (sizeName) {
          sizeName.textContent = state.size || 'Select a size';
          sizeName.classList.remove('warn');
        }
        const meta = $('[data-sticky-meta]', sec);
        if (meta) meta.textContent = `${state.color || ''}${state.color ? ' · ' : ''}${state.size || 'Pick a size'} · ${money(shown.p)}`;
        if (v) {
          const url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url);
        }
      };

      const setColor = (name) => {
        state.color = name;
        const btn = $$('[data-color-btn]', sec).find((b) => b.dataset.color === name);
        $$('[data-color-btn]', sec).forEach((b) => {
          const on = b === btn;
          b.classList.toggle('on', on);
          b.setAttribute('aria-checked', on);
        });
        if (btn) {
          sec.style.setProperty('--tee-color', btn.dataset.hex);
          sec.classList.toggle('is-light', !!btn.dataset.light);
        }
        $$('[data-color-name]', sec).forEach((el) => (el.textContent = name));
        const photo = data.variants.find((v) => v.c === name && v.img)?.img;
        if (photo) {
          $$('[data-photo]', sec).forEach((img) => {
            img.src = `${photo}${photo.includes('?') ? '&' : '?'}width=${img.dataset.photo}`;
            img.removeAttribute('srcset');
          });
        }
        update();
      };

      const go = (i) => {
        if (!slides.length) return;
        state.slide = (i + slides.length) % slides.length;
        slides.forEach((s, j) => {
          s.classList.toggle('on', j === state.slide);
          s.setAttribute('aria-hidden', j !== state.slide);
        });
        thumbs.forEach((t, j) => {
          t.classList.toggle('on', j === state.slide);
          t.setAttribute('aria-current', j === state.slide);
        });
        if (caption) caption.textContent = slides[state.slide].dataset.caption || '';
        main?.classList.remove('zoom');
      };

      const add = async () => {
        if (data.hasSize && !state.size) {
          const z = $('[data-sizes]', sec);
          if (!reduced) z?.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-8px)' }, { transform: 'translateX(8px)' }, { transform: 'translateX(0)' }], { duration: 300 });
          if (sizeName) {
            sizeName.textContent = 'Pick your size first';
            sizeName.classList.add('warn');
          }
          $('[data-buy-box]', sec)?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          $('[data-size-btn]', sec)?.focus({ preventScroll: true });
          return;
        }
        const v = current();
        if (!v || !v.a) return;
        const qty = Math.max(1, Number(qtyInput?.value) || 1);
        [addBtn, stickyAdd].forEach((b) => b?.setAttribute('aria-busy', 'true'));
        try {
          await addToCart(v.id, qty);
          toast(`Added ${qty} × ${data.name}: ${[state.color, state.size].filter(Boolean).join(', ')}`);
        } catch (err) {
          toast(err.message, true);
        } finally {
          [addBtn, stickyAdd].forEach((b) => b?.removeAttribute('aria-busy'));
        }
      };

      sec.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;
        const cb = t.closest('[data-color-btn]');
        if (cb) return setColor(cb.dataset.color);
        const sb = t.closest('[data-size-btn]');
        if (sb) {
          state.size = sb.dataset.size;
          return update();
        }
        const th = t.closest('.thumb-btn');
        if (th) return go(Number(th.dataset.i));
        if (t.closest('[data-prev]')) return go(state.slide - 1);
        if (t.closest('[data-next]')) return go(state.slide + 1);
        if (t.closest('[data-qty-step]')) {
          const step = Number(t.closest('[data-qty-step]').dataset.qtyStep);
          qtyInput.value = Math.min(99, Math.max(1, (Number(qtyInput.value) || 1) + step));
          return update();
        }
        if (t.closest('[data-sticky-add]')) return add();
        if (t.closest('[data-open-guide]')) return openDialog(`guide-${data.sid}`);
        const unit = t.closest('.unit button');
        if (unit) {
          $$('.unit button', sec).forEach((b) => {
            b.classList.toggle('on', b === unit);
            b.setAttribute('aria-pressed', b === unit);
          });
          $$('[data-in]', sec).forEach((td) => {
            const v = Number(td.dataset.in);
            td.textContent = unit.dataset.u === 'in' ? v : (v * 2.54).toFixed(1);
          });
          return;
        }
        if (main && t.closest('[data-main-img]') && !t.closest('.arrows')) main.classList.toggle('zoom');
      });
      qtyInput?.addEventListener('change', update);
      form?.addEventListener('submit', (e) => {
        e.preventDefault();
        add();
      });
      main?.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(state.slide + 1);
        if (e.key === 'ArrowLeft') go(state.slide - 1);
      });
      let sx = 0;
      main?.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
      main?.addEventListener('touchend', (e) => {
        const d = e.changedTouches[0].clientX - sx;
        if (Math.abs(d) > 40) go(state.slide + (d < 0 ? 1 : -1));
      });

      const sticky = $('[data-sticky]', sec);
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.bottom < 0;
          sticky.classList.toggle('on', show);
          sticky.inert = !show;
        }).observe(addBtn);
        sticky.inert = true;
      }

      setColor(state.color);
      go(0);
    });
  }

  /* ---------- contact ---------- */
  function initContact(root) {
    $$('[data-contact]', root).forEach((sec) => {
      if (sec._init) return;
      sec._init = true;
      const form = $('form', sec);
      if (!form) return;
      const msg = $('textarea', form);
      const setTopic = (t) => {
        const r = $(`input[name="contact[Topic]"][data-t="${t}"]`, form);
        if (r) r.checked = true;
        $('[data-order-field]', form)?.classList.toggle('show', t === 'order' || t === 'return');
        $('[data-qty-field]', form)?.classList.toggle('show', t === 'group');
        if (msg && r?.dataset.ph) msg.placeholder = r.dataset.ph;
      };
      form.addEventListener('change', (e) => {
        if (e.target.matches?.('input[name="contact[Topic]"]')) setTopic(e.target.dataset.t);
      });
      $('[data-group-btn]', sec)?.addEventListener('click', (e) => {
        e.preventDefault();
        setTopic('group');
        $('[data-form-card]', sec)?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        setTimeout(() => $('[name="contact[name]"]', form)?.focus({ preventScroll: true }), 500);
      });
      const checks = [
        ['contact[name]', (v) => v.trim().length > 1],
        ['contact[email]', (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)],
        ['contact[body]', (v) => v.trim().length > 3],
      ];
      form.addEventListener('submit', (e) => {
        let first = null;
        checks.forEach(([name, fn]) => {
          const el = form.elements[name];
          if (!el) return;
          const ok = fn(el.value);
          el.closest('.field')?.classList.toggle('err', !ok);
          el.setAttribute('aria-invalid', !ok);
          if (!ok && !first) first = el;
        });
        if (first) {
          e.preventDefault();
          first.focus();
        }
      });
      form.addEventListener('input', (e) => {
        const f = e.target.closest?.('.field');
        if (f) {
          f.classList.remove('err');
          e.target.removeAttribute('aria-invalid');
        }
      });
      setTopic($('input[name="contact[Topic]"]:checked', form)?.dataset.t || 'order');
    });
  }

  /* ---------- boot ---------- */
  function init(root = document) {
    initReveal(root);
    initTabs(root);
    initCollection(root);
    initProduct(root);
    initContact(root);
  }
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  window.BHO.toast = toast;
  window.BHO.addToCart = addToCart;
})();
